<template>
    <SupportCulturalProgram />
</template>

<script>
    import SupportCulturalProgram from '../components/SupportCulturalProgram.vue'

    export default {
        name: 'support-cultural-program',
        components: {
            SupportCulturalProgram
        }
    }
</script>